import {createContext, type PropsWithChildren, useContext, useMemo} from 'react'

export type AlignmentType = 'top' | 'center'

export type AlignmentContextProps = {
  /**
   * Alignment for the leading content
   */
  alignment: AlignmentType
}

const AlignmentContext = createContext<AlignmentContextProps>({alignment: 'top'})

export const AlignmentProvider = ({alignment, children}: PropsWithChildren<{alignment?: AlignmentType}>) => {
  const contextProps = useMemo(() => ({alignment: alignment ?? 'top'}) satisfies AlignmentContextProps, [alignment])
  return <AlignmentContext.Provider value={contextProps}>{children}</AlignmentContext.Provider>
}
AlignmentProvider.displayName = 'ListItemAlignmentProvider'

export const useListItemAlignment = () => {
  return useContext(AlignmentContext)
}

try{ AlignmentContext.displayName ||= 'AlignmentContext' } catch {}